export default "__VITE_ASSET__CL8bO9Js__"